@for (filterGroup of filters; track $index) {
  @if (filterGroup.filters.length > 1 || (filterGroup.filters.length === 1 && !filterGroup.activeFilters?.length)) {
    <div id="filterContainer" class="d-flex flex-row justify-content-center b-2">
      <div class="d-flex justify-content-center align-items-center p-1">
        @if (labels && labels[$index] && filters[$index].requestAmount) {
          <mat-icon class="icon" [matTooltip]="labels[$index] | translate">info</mat-icon>
        }
      </div>
      <div class="filters d-flex scrollbar-styled-smaller px-1 py-1" style="overflow-x: auto">
        @for (filter of filterGroup.filters; track $index) {
          @if (filter.amount > 0) {
            <button
              (click)="activateFilter(filter, filterGroup)"
              class="mx-2 badge"
              mat-stroked-button
              [matBadge]="filter.amount > 99 ? '99+' : filter.amount"
              matBadgePosition="after"
              matBadgeColor="accent"
              [ngClass]="{ active: filterGroup.activeFilters?.includes(filter) ?? false }"
              style="min-width: max-content"
            >
              {{ filter.title | translate }}
            </button>
          }
        }
      </div>
    </div>
  }
}

<!-- *ngIf="filter.amount > 0  && filter.amount !== filterGroup.requestAmount" -->
